export default function FinalAgreement() {
  return (
    <div className="text-sm">
      By pressing the "Complete Your Enrollment" button, you certify that you
      are at least 18 years old and that you agree to the{" "}
      <a
        className="kup-link"
        href="/terms-of-use"
        rel="noreferrer noopener"
        target="_blank"
      >
        Terms of Use
      </a>{" "}
      and{" "}
      <a
        className="kup-link"
        href="/privacy-policy"
        rel="noreferrer noopener"
        target="_blank"
      >
        Privacy Policy
      </a>{" "}
      (
      <a
        className="kup-link"
        href="/privacy-policy-addendum-for-california-residents"
        rel="noreferrer noopener"
        target="_blank"
      >
        CA Notice At Collection
      </a>
      ).
      <br />
      <br />
      If you are under 18, please have your parent/guardian complete your
      enrollment.
    </div>
  );
}
